export default __webpack_public_path__ + "static/media/pediatrician.3a1ad3d7.png";